import React, {useState} from 'react';
import emailjs from 'emailjs-com';
import {Link}  from 'react-router-dom';
import api from '../../services/api.js';
import './ResetSenha.css';

function ResetSenha(){

  const [email, setEmail] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [sucesso, setSucesso] = useState('');
  const [nome, setNome] = useState('');
  const [senha, setSenha] = useState('');
  const [mailto, setMailto] = useState('');

 
  async function recuperarSenha(){

    if (email==='') {
        setMensagem('Favor informar o email de recuperação !');
        return;        
    }
        
    if  (! email.match('@')) {
        setMensagem('Favor informar um Email válido !');
        return;
    }        
    const response = await api.get('/cliente/login/verificaemail.php/?e='+email);

    if (response.data[0].Nome==='') {
        setMensagem('Nenhum usuário encontrado com o email informado !');
        return;        
    }
    setNome(response.data[0].Nome);
    setSenha();
    setMailto(email);
    setMensagem('');
    var templateParams = {
        from_name : 'Área do cliente Solaris',
        to_name : response.data[0].Nome,
        senha : response.data[0].Senha,
        to_email : email,
        msg_txt : 'Senha de recuperação : '+response.data[0].Senha
};

emailjs.send('service_xbj4pgn','template_9k4gpfw',templateParams,'5Fne87sQSpu7iL60q')
.then(function(response){console.log('Enviado com sucesso !',response.status,response.text);},
function(error){console.log('Falha ao enviar !',error);});

console.log(templateParams);


  }

    return <div className="d-flex align-items-center text-center form-container">
      <form className="form-signin">
        <img className="mb-4" src="/Images/logo-small2.png" alt="" />
        <h1 className="h3 mb-3 fw-normal">Recuperar Senha</h1>

        <div className="form-floating">
          <input onChange={(e) => setEmail(e.target.value)} type="email" className="form-control" id="floatingInput" placeholder="E-mail" />
          <label for="floatingInput">E-mail</label>
        </div>
             
        <button onClick={recuperarSenha} className="w-100 btn btn-lg btn-primary mt-3" type="button">Enviar</button>

        {mensagem.length > 0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}
        {sucesso.length > 0 ? <div className="alert alert-success mt-2" role="alert">{sucesso}</div> : null}

        <div className="login-links mt-5">
          <Link to="/" className="mx-3">Voltar à tela anteior</Link>
        </div>

        <p className="mt-5 mb-1 text-muted">&copy; Desenvolvido por River Clear Development Systems</p>
        
      </form>
    </div>
  }

export default ResetSenha;